










import { Vue, Component, Watch } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import { NotificationData } from '@/Infrastructure/Store/Auction/NotificationData'
import NotificationsForm from '@/UI/Auction/Notifications/NotificactionsForm.vue'
import { PersonalData } from '@/Infrastructure/Store/Auction/PersonalData'
import { RepresentationData } from '@/Infrastructure/Store/Auction/RepresentationData'

const notificationStore = namespace('auction')
@Component({
  components: { NotificationsForm }
})

export default class NotificationDetail extends Vue {
  continuar = false

  @notificationStore.Getter
  public notification!: NotificationData

  @notificationStore.Getter
  public personalData!: PersonalData

  @notificationStore.Getter
  public representationData!: RepresentationData

  @notificationStore.Action
  public setNotification!: (NotificationData: NotificationData) => void

  @Watch('continuar')
  onContinuarChanged (val: boolean): void {
    if (val) {
      this.$emit('formValid', true)
    } else {
      this.$emit('formValid', false)
    }
  }

  onNotificactionDataUpdated ($event: NotificationData): void {
    this.setNotification($event)
  }
}
